import {
  subscriptionService,
  getCoupon,
  getOrganizationSettings,
} from "../services/stripeServices";
import {
  IS_FETCHING_STRIPE,
  SET_STRIPE_ERROR_MESSAGE,
  SET_STRIPE_COUPON,
  SET_STRIPE_INCORRECT_COUPON,
} from "./actionsTypes";
import { getErrorMessageFromRequestError } from "../../shared/helpers/messages/request";
import {
  setFetching,
  setError,
} from "../../shared/request/actions/requestActions";

export const setIsFetchingStripe = ({ isFetching }) => ({
  type: IS_FETCHING_STRIPE,
  payload: { isFetching },
});

export const setStripeErrorMessage = ({ errorMessage }) => ({
  type: SET_STRIPE_ERROR_MESSAGE,
  payload: { errorMessage },
});

export const setCoupon = (coupon) => ({
  type: SET_STRIPE_COUPON,
  payload: coupon,
});

export const setIncorrectCoupon = (status) => ({
  type: SET_STRIPE_INCORRECT_COUPON,
  payload: status,
});

export const subscription =
  ({ username, password }) =>
  async (dispatch) => {
    dispatch(setIsFetchingStripe({ isFetching: true }));
    try {
      await subscriptionService({ username, password });
    } catch (e) {
      const errorMessage = getErrorMessageFromRequestError(e);
      dispatch(setStripeErrorMessage({ errorMessage }));
    } finally {
      dispatch(setIsFetchingStripe({ isFetching: false }));
    }
  };

export const asyncGetCoupon =
  (promotionCodeId, landingPage) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));
    try {
      let organizationSettings = null;
      let trialPeriodDays = 0;
      const response = await getCoupon(promotionCodeId, landingPage);

      if (response.data.data.organizationId > 0) {
        organizationSettings = await getOrganizationSettings(
          response.data.data.organizationId
        );

        trialPeriodDays = organizationSettings.data.data.trialPeriodDays;
      }
      dispatch(setCoupon({ ...response.data.data, trialPeriodDays }));
      dispatch(setIncorrectCoupon(true));
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);
      dispatch(setIncorrectCoupon(false));
      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };
